export const CONTENTSTACK_DEFAULT_PAGE_LIST = [
    '/m/customer-service/jewelry-faq',
    '/m/editorial/guides/mini-editorial/5-pieces-of-jewelry-to-own-right-now',
    '/m/editorial/guides/mini-editorial/animal-print-texture',
    '/m/editorial/guides/mini-editorial/back-to-school-ready-kids',
    '/m/editorial/guides/mini-editorial/backyard-fun',
    '/m/editorial/guides/mini-editorial/boho-trends',
    '/m/editorial/guides/mini-editorial/celebrity-looks-for-less',
    '/m/editorial/guides/mini-editorial/cozy-home',
    '/m/editorial/guides/mini-editorial/day-of-the-dead',
    '/m/editorial/guides/mini-editorial/dress-for-your-season',
    '/m/editorial/guides/mini-editorial/earth-day-picks',
    '/m/editorial/guides/mini-editorial/endless-summer',
    '/m/editorial/guides/mini-editorial/home-seasonal-color-palette',
    '/m/insidelane',
    '/m/editorial/guides/mini-editorial/jewelry-trends-2026',
    '/m/editorial/guides/mini-editorial/look-good-feel-better',
    '/m/editorial/guides/mini-editorial/match-day',
    '/m/editorial/guides/mini-editorial/meet-your-new-denim',
    '/m/editorial/guides/mini-editorial/mothers-day-gift-guide-2026',
    '/m/editorial/guides/mini-editorial/nancy-meyers-home-refresh',
    '/m/editorial/guides/mini-editorial/new-classics',
    '/m/editorial/guides/mini-editorial/regency-era-inspo',
    '/m/editorial/guides/mini-editorial/sports-couture',
    '/m/editorial/guides/mini-editorial/spring-footwear-trends-2026',
    '/m/editorial/guides/mini-editorial/summer-beauty-glow-up-2026',
    '/m/editorial/guides/mini-editorial/summerween',
    '/m/editorial/guides/mini-editorial/the-patio-edit-2026',
    '/m/editorial/guides/mini-editorial/trending-in-2026',
    '/m/editorial/guides/mini-editorial/unexpected-dorm-finds',
    '/m/editorial/guides/mini-editorial/vacation-essentials',
    '/m/editorial/guides/mini-editorial/vacation-travel-2026',
    '/m/editorial/guides/mini-editorial/valentine-gifts',
    '/m/editorial/guides/mini-editorial/whats-your-fragrance-profile',
    '/m/editorial/guides/mini-editorial/winter-refresh',
    '/m/editorial/guides/blinds-shades-guide',
    '/m/editorial/guides/cooking-appliance-guide',
    '/m/editorial/guides/curtains-drapes-guide',
    '/m/editorial/guides/household-appliance-guide',
    '/m/editorial/guides/jenny-martinez',
    '/m/editorial/living',
    '/m/editorial/guides/luggage-101',
    '/m/editorial/guides/mattress-buying-guide',
    '/m/editorial/guides/bath-towels-guide',
    '/m/jewelry-buying-guides',
    '/m/editorial/guides/big-and-tall-buying-guide',
    '/m/editorial/guides/bra-fit-guide',
    '/m/editorial/guides/decorative-bedding-buying-guide',
    '/m/editorial/guides/dress-for-a-job-interview',
    '/m/pillows-buying-guide',
    '/m/editorial/guides/quilts-buying-guide',
    '/m/editorial/guides/sheets-buying-guide',
    '/m/editorial/guides/swimwear-buying-guide',
    '/m/tailored-clothing',
    '/m/editorial/guides/womens-outerwear-buying-guide',
    '/m/editorial/style/the-perfect-engagement',
    '/m/measuring-for-blinds-shades',
    '/m/textured-hair-glossary',
    '/m/editorial/guides/children-clothing-size-chart',
    '/m/editorial/guides/5-best-jewelry-wedding-gifts-from-groom-to-bride',
    '/m/editorial/guides/anniversary-bands-rings-guide',
    '/m/editorial/guides/anniversary-gift-jewelry-guide-for-her',
    '/m/april-birthstone-diamond-white-sapphire',
    '/m/editorial/guides/august-birthstone-peridot',
    '/m/editorial/guides/how-to-wear-and-stack-multiple-earrings',
    '/m/july-birthstone-ruby',
    '/m/october-birthstone-opal',
    '/m/ring-jewelry-guide',
    '/m/unique-holiday-jewelry-gift-ideas',
    '/m/editorial/guides/what-is-a-bridal-set',
    '/m/editorial/guides/birthstone-jewelry-guide-meaning',
    '/m/editorial/living/clean-home-clear-mind',
    '/m/editorial/guides/coffee-and-tea-buying-guide',
    '/m/editorial/guides/decorate-your-space',
    '/m/diamond-4cs-cut-carat-clarity-color',
    '/m/diamond-jewelry-care-buying-guide',
    '/m/fine-jewelry-care-plan',
    '/m/editorial/guides/floor-care-buying-guide',
    '/m/editorial/guides/home-office-decor',
    '/m/editorial/guides/how-much-to-pay-for-an-engagement-ring',
    '/m/editorial/guides/how-to-choose-the-perfect-wedding-band',
    '/m/editorial/guides/jewelry-stocking-stuffer-ideas',
    '/m/june-birthstone-pearl-guide',
    '/m/editorial/guides/laundry-care-buying-guide',
    '/m/editorial/guides/necklace-buying-guide',
    '/m/editorial/guides/rugs-buying-guide',
    '/m/valentines-day-jewelry-guide-gifts-for-her',
    '/m/editorial/guides/watch-buying-guide',
    '/m/editorial/guides/ways-to-gift-jewelry-for-the-holidays',
    '/m/christmas-tree-buying-guide',
    '/m/editorial/guides/false-eyelashes-guide',
    '/m/editorial/guides/footwear-101-must-have-shoes-for-women',
    '/m/editorial/guides/makeup-tips-guide',
    '/m/editorial/guides/makeup-tools-guide',
    '/m/editorial/guides/mens-dress-shoes-boots-guide',
    '/m/editorial/guides/mens-formal-fashion-guide',
    '/m/editorial/guides/stainless-steel-guide',
    '/m/textured-hair-curl-type-guide',
    '/m/editorial/guides/wedding-attire-guide',
    '/m/editorial/guides/womens-suits-separates-guide',
    '/m/editorial/guides/affordable-engagement-ring-guide',
    '/m/editorial/guides/anniversary-gift-jewelry-guide-for-him',
    '/m/editorial/guides/best-way-to-wear-stackable-rings-jewelry-trend',
    '/m/december-birthstone-blue-topaz',
    '/m/february-birthstone-amethyst',
    '/m/editorial/guides/how-use-cast-iron-cookware',
    '/m/january-birthstone-garnet',
    '/m/march-birthstone-guide',
    '/m/may-birthstone-emerald-guide',
    '/m/mothers-day-jewelry-gift-ideas',
    '/m/november-birthstone-citrine',
    '/m/editorial/guides/promise-rings-meaning-guide',
    '/m/september-birthstone-sapphire',
    '/m/editorial/guides/what-is-a-halo-ring',
    '/m/editorial/guides/7-tips-on-how-to-layer-necklaces',
    '/m/editorial/guides/choosing-the-best-jewelry-metal-type',
    '/m/editorial/guides/how-to-find-the-best-engagement-ring',
    '/m/how-to-give-surprise-jewelry-gift',
    '/m/editorial/guides/how-to-wear-stackable-bracelets',
    '/m/editorial/guides/mens-wedding-band-ring-buying-guide',
    '/m/editorial/guides/cutlery-buying-guide',
    '/m/editorial/guides/juicing-guide',
    '/m/editorial/living/dorm-makeover',
    '/m/editorial/living/fall-gift-guide',
    '/m/editorial/living/healthy-habits-2026',
    '/m/editorial/living/holiday-family-photos',
    '/m/editorial/living/holiday-gift-guide',
    '/m/editorial/living/holiday-hosting-dinner-party',
    '/m/editorial/living/holiday-preppers-unite',
    '/m/editorial/living/holiday-traditions',
    '/m/editorial/living/meet-liz-claiborne',
    '/m/editorial/living/moms-day-her-way',
    '/m/editorial/living/outdoor-home',
    '/m/editorial/living/ring-in-the-new-year-right',
    '/m/editorial/living/spring-gift-guide',
    '/m/editorial/living/summer-celebrations',
    '/m/editorial/living/vacation-ready',
    '/m/editorial/guides/athletic-shoes-shopping-guide',
    '/m/editorial/guides/teen-formalwear',
    '/m/editorial/guides/trendy-graphic-tees-buying-guide',
    '/m/editorial/guides/womens-capsule-wardrobe-benchmarks',
    '/m/editorial/guides/affordable-brand-name-sneakers',
    '/m/editorial/guides/affordable-high-end-makeup-routine',
    '/m/editorial/guides/affordable-makeup-brands',
    '/m/editorial/guides/cross-training-shoes-for-women',
    '/m/editorial/guides/the-modern-fit-check-womens-fashion-trends',
    '/m/editorial/guides/duvet-vs-comforter',
    '/m/editorial/style/what-is-fine-jewelry',
    '/m/editorial/guides/christmas-gifts-for-dad',
    '/m/editorial/guides/christmas-gifts-for-kids',
    '/m/editorial/guides/what-size-newborn-clothes',
    '/m/editorial/style/dressing-for-your-body-type',
    '/m/editorial/style/easy-monochrome-outfits',
    '/m/accessibility-statement',
    '/m/ayuda',
    '/m/editorial/beauty/beauty-gift-ideas',
    '/m/ca-transparency-in-supply-chains-act',
    '/m/customer-service/change-or-cancel-an-order',
    '/m/email-terms-and-conditions',
    '/m/customer-service/furniture-and-mattress-protection-plan-faq',
    '/m/furniture-and-mattress-return-policy',
    '/m/garant-as',
    '/m/hoax-emails-messages-phishing',
    '/m/legal',
    '/m/optical-closure',
    '/m/customer-service/our-lowest-price-guarantee',
    '/m/editorial/guides/personalized-gift-suggestions',
    '/m/pol-tica-de-devoluciones',
    '/m/pol-tica-de-privacidad',
    '/m/customer-service/pricing',
    '/m/privacy-notice',
    '/m/customer-service/privacy-rights',
    '/m/customer-service/product-safety',
    '/m/protection-plan-faq',
    '/m/customer-service/rebates',
    '/m/customer-service/recycle-fee-info',
    '/m/customer-service/return-exceptions',
    '/m/reward-term-and-conditions',
    '/m/rewards-exclusive-offer-sms',
    '/m/rewards-redemptions-exclusions',
    '/m/customer-service/rewards-terms-and-conditions',
    '/m/servicio-al-cliente-en-espa-ol',
    '/m/tarifas-e-informaci-n-sobre-env-os',
    '/m/tarjetas-de-regalo',
    '/m/customer-service/your-california-privacy-rights',
    '/m/app-wallet',
    '/m/asian-american-pacific-islander-month',
    '/m/black-excellence',
    '/m/black-ownedfoundedbrands',
    '/m/breast-cancer-awareness-month',
    '/m/inclusive-beauty',
    '/m/juneteenth',
    '/m/pride-month',
    '/m/really-big-deals',
    '/m/suit-up-event',
    '/m/editorial/wedding-inspo',
    '/m/womens-history-month',
    '/m/xersion-family-activewear',
    '/m/baby-checklist',
    '/m/hurst-photography',
    '/m/retail-rejuvenation',
    '/m/rewards-faqs',
    '/m/supplier-diversity-faq',
    '/m/supplier-diversity-overview',
    '/m/community',
    '/m/company-info',
    '/m/contact-info',
    '/m/customer-service',
    '/m/getting-started',
    '/m/gift-card-m2',
    '/m/customer-service/gift-cards-e-gift-cards',
    '/m/jcp-supplier-diversity',
    '/m/jewelry-financing-promotion',
    '/m/kids-club',
    '/m/opciones-de-pago',
    '/m/customer-service/payment-options',
    '/m/plcc-benefits',
    '/m/customer-service/product-recalls',
    '/m/promo-affshop1',
    '/m/promo-rakuten1',
    '/m/promo-rmn15',
    '/m/promo-svgunt15',
    '/m/customer-service/returns',
    '/m/same-day-pickup',
    '/m/customer-service/shipping-information',
    '/m/site-map',
    '/m/sms-digitalacquisition1',
    '/m/sms-order-status-terms',
    '/m/sms-terms-and-conditions',
    '/m/special-promotional-financing',
    '/m/customer-service/synchrony-pay-later',
    '/m/tax-free',
    '/m/window-promo-financing',
    '/m/coupon-exclusions',
    '/m/sms-digitalacquisition4',
    '/m/editorial/beauty/beauty-buyer-picks',
    '/m/friendsgiving',
    '/m/editorial/style/summer-preview',
    '/m/editorial/style/trends-we-love',
    '/m/editorial/beauty/wedding-beauty-prep',
    '/m/editorial/style/10-things-for-spring',
    '/m/editorial/style/5-must-have-dresses',
    '/m/editorial/style/ashley-graham',
    '/m/editorial/beauty',
    '/m/editorial/guides/beauty-education',
    '/m/editorial/beauty/beauty-trends',
    '/m/editorial/style/business-casual-outfits-on-a-budget',
    '/m/editorial/collaborations',
    '/m/editorial/beauty/complexion-perfection',
    '/m/editorial',
    '/m/editorial/style/fall-preview',
    '/m/editorial/style/find-your-active-style',
    '/m/editorial/style/getaway-bag-must-haves',
    '/m/editorial/grown-gorgeous-where-love-shines-brightest',
    '/m/editorial/living/guest-ready-for-the-holidays',
    '/m/editorial/beauty/healthy-skin-is-in',
    '/m/editorial/guides/jcpenney-holiday-portraits-lifetouch',
    '/m/jcpenney-salon-trend-lookbook',
    '/m/editorial/style/jcpenney-x-jason-bolden',
    '/m/editorial/guides/mini-editorial',
    '/m/now-trending',
    '/m/editorial/style/prabal-gurung-for-jcpenney',
    '/m/editorial/seasonal',
    '/m/editorial/style/spring-trends',
    '/m/editorial/style',
    '/m/editorial/style/summer-blues',
    '/m/editorial/style/travel-tips-for-all-your-trips',
    '/m/editorial/style/winter-wardrobe-must-haves',
    '/m/bra-guide',
    '/m/jewelry-education',
    '/m/diamond-buying-guide',
    '/m/diamond-jewelry-repair',
    '/m/editorial/guides/dinnerware-buying-guide',
    '/m/down-down-alternative-buying-guide',
    '/m/editorial/guides/down-and-down-alternative-comforters-buying-guide',
    '/m/editorial/guides/essential-handbag-guide',
    '/m/editorial/guides/essential-kitchen-tools',
    '/m/editorial/guides/flatware-buying-guide',
    '/m/editorial/guides/foundation-101',
    '/m/editorial/guides/foundation-concealer-makeup-shade-guide',
    '/m/customer-service/furniture-and-mattress-customer-care-center',
    '/m/gemstone-background',
    '/m/editorial/guides',
    '/m/editorial/guides/hair-styling-tools-guide',
    '/m/editorial/guides/hairspray-guide',
    '/m/editorial/guides/mini-editorial/halloween-preview',
    '/m/home-inspiration',
    '/m/how-to-choose-best-diamond-shape',
    '/m/editorial/guides/choosing-the-right-sneakers-comfort-durability',
    '/m/editorial/guides/how-to-pick-the-perfect-perfume-6-steps-to-finding-your-signature-scent',
    '/m/editorial/guides/how-to-set-a-table',
    '/m/editorial/guides/how-to-use-a-face-sculptor',
    '/m/editorial/guides/how-to-use-a-gua-sha',
    '/m/editorial/guides/lab-grown-diamond-guide',
    '/m/editorial/guides/lighting-buying-guide',
    '/m/mattress-pads-toppers-buying-guide',
    '/m/editorial/guides/men-denim-guide',
    '/m/precious-metals-buying-guide',
    '/m/ring-size-guide',
    '/m/editorial/guides/shoes-jeans-guide',
    '/m/simstyled-for-jcpenney',
    '/m/skincare-glossary',
    '/m/editorial/guides/smart-watch-guide',
    '/m/editorial/guides/mini-editorial/summer-trends-2026',
    '/m/vacation',
    '/m/watch-care-plan',
    '/m/editorial/guides/window-hardware-buying-guide',
    '/m/editorial/guides/women-denim-guide',
    '/m/editorial/guides/womens-shapewear',
    '/m/jewelry-addiction-collections',
    '/m/jewelry-collections',
    '/m/modernbride',
    '/m/opalex-service-menu',
    '/m/beauty-in-store-offers',
    '/m/beauty-services',
    '/m/deva-curl-service-menu',
    '/m/jewelry-watches-character-shop',
    '/m/editorial/guides/mens-outerwear-buying-guide',
    '/m/messi',
    '/m/murad-service-menu',
    '/m/service-menu',
    '/m/customer-service/shop-and-hold',
    '/m/editorial/guides/mini-editorial/awards-season-style',
    '/m/editorial/guides/mini-editorial/summer-beauty',
    '/m/editorial/guides/mini-editorial/wickedly-stylish',
    '/m/capone15',
    '/m/commercial-offer-details',
    '/m/bath-rug-101',
    '/m/bath-towels-sizes-and-care',
    '/m/jcp-beauty-store-openings',
    '/m/ashley-graham-store-list',
    '/m/jingle-ball-store-list',
    '/m/mattress-store-list',
    '/m/messi-store-list',
    '/m/murad-salon-service-locations',
    '/m/nike-store-locations',
    '/m/rene-by-rene-ruiz-store-list',
    '/m/team-sports-store-locations',
    '/m/official-rules',
    '/m/editorial/style/fall-fashion-2026',
    '/m/editorial/living/blackout-curtains-guide',
    '/m/editorial/living/bath-towels-guide',
    '/m/editorial/guides/christmas-holiday-beauty-gift-basket-ideas',
    '/m/marilyn-monroe-store-list',
];